/**
 * 감정 패널티 실시간 목록 API.
 * 별도 적재 없이 서버에서 산출한다.
 */
import api from './index'

/**
 * @returns {Promise} { code, items: PenaltyLine[] }
 */
export function getAppraisalPenaltyList() {
  return api.get('/api/v1/appraisal-penalties')
}
